import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LottieDirectiveSharedModule } from '@shared/core/directives/lottie/lottie.directive.shared.module';
import { BtnModule } from '@shared/core/components/buttons/btn/btn.shared.module';
import { AuthComponentsModule } from '../../components';

import { AuthForUniqueCodeErrorComponent } from './auth-for-unique-code-error.shared.component';

@NgModule({
    declarations: [
        AuthForUniqueCodeErrorComponent
    ],
    imports: [
        CommonModule,
        BtnModule,
        LottieDirectiveSharedModule,
        AuthComponentsModule,
    ],
    exports: [
        AuthForUniqueCodeErrorComponent
    ],
})
export class AuthForUniqueCodeErrorModule { }
